export enum DATERANGES {
	ALL = 'all',
	ONE_HOUR = '1h',
	ONE_DAY = '1d',
	ONE_WEEK = '1w',
	ONE_MONTH = '1M',
	ONE_YEAR = '1y',
}
